import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';

export const FaucetSection: React.FC = () => {
  const handleFaucetClick = () => {
    window.open('https://claim.shido.io', '_blank', 'noopener,noreferrer');
  };

  return (
    <Card 
      title="Need SHIDO for Gas?" 
      subtitle="Get free SHIDO tokens for your first transactions"
      elevated
    >
      <div className="space-y-4">
        <div className="bg-gradient-to-r from-primary-900/30 to-secondary-900/30 border border-primary-800/50 rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-primary-500/20 rounded-full flex items-center justify-center">
                <svg className="w-4 h-4 text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                </svg>
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-sm font-medium text-primary-300 mb-1">
                Community Funded Faucet
              </h3>
              <p className="text-sm text-gray-300 mb-3">
                New to Shido Network? Claim free SHIDO coins to cover your first transaction fees. 
                Our community-funded faucet helps newcomers get started on the Shido ecosystem.
              </p>
              <div className="flex flex-col sm:flex-row gap-2">
                <Button
                  onClick={handleFaucetClick}
                  variant="primary"
                  size="sm"
                  className="bg-gradient-to-r from-primary-600 to-secondary-600 hover:from-primary-500 hover:to-secondary-500"
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                  Claim Free SHIDO
                </Button>
              </div>
            </div>
          </div>
        </div>
        
        <div className="text-xs text-gray-400 space-y-1">
          <p>• One claim per address to ensure fair distribution</p>
          <p>• Community funded - help others by contributing back when you can</p>
        </div>
      </div>
    </Card>
  );
};
